import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	container: {
		marginRight: 16
	},
	infoIconSize: {
		width: 16,
		height: 16
	}
})

export default useStyles
